import { DATABASE_URL_PLACEHOLDER } from '@cli-constants/scaffolding.js'

export function isPlaceholderValue(value: string): boolean {
  return value === DATABASE_URL_PLACEHOLDER || value.startsWith('your_')
}
